module.exports = __webpack_public_path__ + "img/services.d0dad542.png";